// Note: Copy of ReviewNextStep with REQUIRES_ADDITIONAL_INFORMATION removed
export enum ReviewNextStepClose {
    CLOSE_COD = 'Close COD'
}
